// Remedy data extracted from RemedySearch component

export interface Remedy {
  name: string;
  benefit: string;
}

export interface AilmentData {
  description: string;
  remedies: Remedy[];
  page: number;
  category: string;
  relatedConditions?: string[];
  whenToSeeDoctor?: string;
  applicationForms?: string[];
}

// Mapping von RemedySearch-Schlüsseln zu Ratgeber-Slugs
export const ratgeberMapping: Record<string, { slug: string; title: string }> = {
  // Erkältung & Atemwege
  "erkältung": { slug: "erkaeltung", title: "Erkältung natürlich behandeln" },
  "schnupfen": { slug: "erkaeltung", title: "Erkältung natürlich behandeln" },
  "grippaler infekt": { slug: "erkaeltung", title: "Erkältung natürlich behandeln" },
  
  // Grippe (eigene Seite)
  "grippe": { slug: "grippe", title: "Grippe natürlich behandeln" },
  "influenza": { slug: "grippe", title: "Grippe natürlich behandeln" },
  
  // Husten (eigene Seite)
  "husten": { slug: "husten", title: "Husten natürlich lindern" },
  "reizhusten": { slug: "husten", title: "Husten natürlich lindern" },
  "trockener husten": { slug: "husten", title: "Husten natürlich lindern" },
  "produktiver husten": { slug: "husten", title: "Husten natürlich lindern" },
  
  // Halsschmerzen
  "halsschmerzen": { slug: "halsschmerzen", title: "Halsschmerzen natürlich lindern" },
  "halsweh": { slug: "halsschmerzen", title: "Halsschmerzen natürlich lindern" },
  "schluckbeschwerden": { slug: "halsschmerzen", title: "Halsschmerzen natürlich lindern" },
  
  // Fieber
  "fieber": { slug: "fieber", title: "Fieber natürlich senken" },
  "erhöhte temperatur": { slug: "fieber", title: "Fieber natürlich senken" },
  
  // Kopfschmerzen
  "kopfschmerzen": { slug: "kopfschmerzen", title: "Kopfschmerzen natürlich lindern" },
  "migräne": { slug: "kopfschmerzen", title: "Kopfschmerzen natürlich lindern" },
  "spannungskopfschmerzen": { slug: "kopfschmerzen", title: "Kopfschmerzen natürlich lindern" },
  
  // Schlafprobleme
  "schlafprobleme": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  "schlafstörungen": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  "insomnia": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  "einschlafprobleme": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  "durchschlafprobleme": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  "schlaflosigkeit": { slug: "schlafprobleme", title: "Schlafprobleme natürlich lösen" },
  
  // Verdauung
  "verdauungsprobleme": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "verdauung": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "magen-darm": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "magenschmerzen": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "bauchschmerzen": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "blähungen": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "verstopfung": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "durchfall": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  "sodbrennen": { slug: "verdauung", title: "Verdauungsprobleme natürlich behandeln" },
  
  // Stress
  "stress": { slug: "stress", title: "Stress natürlich abbauen" },
  "nervosität": { slug: "stress", title: "Stress natürlich abbauen" },
  "anspannung": { slug: "stress", title: "Stress natürlich abbauen" },
  "burnout": { slug: "stress", title: "Stress natürlich abbauen" },
  "überlastung": { slug: "stress", title: "Stress natürlich abbauen" },
  
  // Gelenkschmerzen
  "gelenkschmerzen": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  "arthrose": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  "arthritis": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  "rheuma": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  "knieschmerzen": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  "hüftschmerzen": { slug: "gelenkschmerzen", title: "Gelenkschmerzen natürlich lindern" },
  
  // Allergie
  "allergie": { slug: "allergie", title: "Allergie natürlich behandeln" },
  "allergien": { slug: "allergie", title: "Allergie natürlich behandeln" },
  "heuschnupfen": { slug: "allergie", title: "Allergie natürlich behandeln" },
  "pollenallergie": { slug: "allergie", title: "Allergie natürlich behandeln" },
  "hausstauballergie": { slug: "allergie", title: "Allergie natürlich behandeln" },
  
  // Müdigkeit
  "müdigkeit": { slug: "muedigkeit", title: "Müdigkeit natürlich bekämpfen" },
  "erschöpfung": { slug: "muedigkeit", title: "Müdigkeit natürlich bekämpfen" },
  "antriebslosigkeit": { slug: "muedigkeit", title: "Müdigkeit natürlich bekämpfen" },
  "energiemangel": { slug: "muedigkeit", title: "Müdigkeit natürlich bekämpfen" },
  "chronische müdigkeit": { slug: "muedigkeit", title: "Müdigkeit natürlich bekämpfen" },
  
  // Hautprobleme
  "hautprobleme": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  "akne": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  "ekzeme": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  "neurodermitis": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  "psoriasis": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  "trockene haut": { slug: "hautprobleme", title: "Hautprobleme natürlich behandeln" },
  
  // Immunsystem
  "immunschwäche": { slug: "immunsystem", title: "Immunsystem natürlich stärken" },
  "immunsystem": { slug: "immunsystem", title: "Immunsystem natürlich stärken" },
  "abwehrschwäche": { slug: "immunsystem", title: "Immunsystem natürlich stärken" },
  "infektanfälligkeit": { slug: "immunsystem", title: "Immunsystem natürlich stärken" },
  
  // Abnehmen
  "abnehmen": { slug: "abnehmen", title: "Natürlich und gesund abnehmen" },
  "übergewicht": { slug: "abnehmen", title: "Natürlich und gesund abnehmen" },
  "gewichtsabnahme": { slug: "abnehmen", title: "Natürlich und gesund abnehmen" },
  "diät": { slug: "abnehmen", title: "Natürlich und gesund abnehmen" },
};

// Erweiterte Aliase für besseres Fuzzy-Matching
export const aliases: Record<string, string> = {
  // Kopf & Schmerzen
  "kopfweh": "kopfschmerzen",
  "migraine": "migräne",
  "schmerzen kopf": "kopfschmerzen",
  
  // Schlaf
  "einschlafprobleme": "schlafprobleme",
  "nicht schlafen": "schlafprobleme",
  "schlaflosigkeit": "schlafprobleme",
  "insomnie": "schlafprobleme",
  "durchschlafstörungen": "schlafprobleme",
  
  // Erkältung & Atemwege
  "grippe": "erkältung",
  "grippaler infekt": "erkältung",
  "schnupfen": "erkältung",
  "reizhusten": "husten",
  "halsweh": "halsschmerzen",
  "rachentzündung": "halsschmerzen",
  "sinusitis": "nasennebenhöhlenentzündung",
  "nebenhöhlen": "nasennebenhöhlenentzündung",
  "asthma": "atemprobleme",
  "atemnot": "atemprobleme",
  "kurzatmigkeit": "atemprobleme",
  "lungenprobleme": "copd",
  "emphysem": "lungenemphysem",
  
  // Verdauung
  "verdauung": "verdauungsprobleme",
  "verdauungsbeschwerden": "verdauungsprobleme",
  "darm": "verdauungsprobleme",
  "darmprobleme": "verdauungsprobleme",
  "magen-darm": "verdauungsprobleme",
  "magen darm": "verdauungsprobleme",
  "bauchweh": "verdauungsprobleme",
  "magenschmerzen": "verdauungsprobleme",
  "bauchschmerzen": "verdauungsprobleme",
  "blähbauch": "blähungen",
  "völlegefühl": "blähungen",
  "aufgeblähter bauch": "blähungen",
  "obstipation": "verstopfung",
  "diarrhö": "durchfall",
  "magen": "verdauungsprobleme",
  "reflux": "sodbrennen",
  "magenbrennen": "sodbrennen",
  "goldene adern": "hämorrhoiden",
  "analvenenthrombose": "hämorrhoiden",
  "afterbeschwerden": "hämorrhoiden",
  "jucken am after": "afterjucken",
  "analjucken": "afterjucken",
  
  // Psyche
  "burnout": "erschöpfung",
  "panik": "angst",
  "panikattacken": "angst",
  "unruhe": "angst",
  "depressionen": "angst",
  "nervosität": "stress",
  "anspannung": "stress",
  "überarbeitung": "erschöpfung",
  
  // Haut
  "pickel": "akne",
  "unreine haut": "akne",
  "atopische dermatitis": "neurodermitis",
  "schuppenflechte": "ekzeme",
  "psoriasis": "ekzeme",
  "juckende haut": "ekzeme",
  "tinea pedis": "fußpilz",
  "pilzinfektion": "hautpilz",
  "mykose": "hautpilz",
  "falten": "hautalterung",
  "anti aging": "hautalterung",
  "anti-aging": "hautalterung",
  "lippenbläschen": "herpes",
  "fieberbläschen": "herpes",
  "lippenherpes": "herpes",
  "herpes labialis": "herpes",
  "brandwunde": "verbrennungen",
  "verbrennung": "verbrennungen",
  "sonnenstich": "sonnenbrand",
  "uv-schaden": "sonnenbrand",
  
  // Gelenke & Bewegung
  "arthrose": "gelenkschmerzen",
  "rheuma": "gelenkschmerzen",
  "arthritis": "gelenkschmerzen",
  "lumbago": "rückenschmerzen",
  "hexenschuss": "rückenschmerzen",
  "ischias": "rückenschmerzen",
  "verspannungen": "muskelkater",
  "muskelschmerzen": "muskelkater",
  "knochenbruch": "knochenbrüche",
  "fraktur": "knochenbrüche",
  "bluterguss": "prellungen",
  "hämatom": "prellungen",
  "sportverletzung": "prellungen",
  
  // Immunsystem
  "pollenallergie": "heuschnupfen",
  "allergische rhinitis": "heuschnupfen",
  "immunsystem stärken": "immunschwäche",
  "oft krank": "immunschwäche",
  "infektanfällig": "immunschwäche",
  
  // Herz-Kreislauf
  "hypertonie": "bluthochdruck",
  "hoher blutdruck": "bluthochdruck",
  "schlechte durchblutung": "durchblutungsstörungen",
  "kalte hände": "durchblutungsstörungen",
  "kalte füße": "durchblutungsstörungen",
  "varizen": "krampfadern",
  "besenreiser": "krampfadern",
  "venenschwäche": "krampfadern",
  "ulcus cruris": "offene-beine",
  "unterschenkelgeschwür": "offene-beine",
  
  // Parasiten & Körperpflege
  "läuse": "kopfläuse",
  "kopfparasiten": "kopfläuse",
  "nissen": "kopfläuse",
  "skabies": "krätze",
  "milben": "krätze",
  "hautmilben": "krätze",
  "kopfhautschuppen": "schuppen",
  "seborrhoe": "schuppen",
  "fußgeruch": "schweißfüße",
  "stinkefüße": "schweißfüße",
  
  // HNO & Ohren
  "ohrenschmerzen": "mittelohrentzündung",
  "otitis": "mittelohrentzündung",
  "otitis media": "mittelohrentzündung",
  "ohrentzündung": "mittelohrentzündung",
  
  // Frauengesundheit
  "vaginalpilz": "scheidenpilz",
  "vaginalinfektion": "scheidenpilz",
  "pilz scheide": "scheidenpilz",
  "periode": "menstruationsbeschwerden",
  "regelschmerzen": "menstruationsbeschwerden",
  "pms": "menstruationsbeschwerden",
  "klimakterium": "wechseljahresbeschwerden",
  "hitzewallungen": "wechseljahresbeschwerden",
  
  // Männergesundheit
  "impotenz": "potenzprobleme",
  "erektionsstörungen": "potenzprobleme",
  "libido": "potenzprobleme",
  "prostata": "prostatabeschwerden",
  "harndrang": "prostatabeschwerden",
  
  // Mund & Zähne
  "mundpilz": "soor",
  "mundsoor": "soor",
  "candida mund": "soor",
  "zahnbelag": "karies",
  "plaque": "karies",
  "löcher": "karies",
  "parodontose": "paradentose",
  "zahnfleischbluten": "zahnfleischentzündung",
  "gingivitis": "zahnfleischentzündung",
  "lockere zähne": "paradentose",
  "zahnbetterkrankung": "paradentose",
  
  // Augen
  "grüner star": "glaukom",
  "augeninnendruck": "glaukom",
  "sehprobleme": "augenprobleme",
  "bindehautentzündung": "augenentzündung",
  "rote augen": "augenentzündung",
  "keratitis": "hornhautentzündung",
  
  // Baby & Kinder
  "windelausschlag": "windeldermatitis",
  "windelpilz": "windeldermatitis",
  "wunder po": "windeldermatitis",
  "babypopo": "windeldermatitis",
  
  // Erste Hilfe
  "schnitt": "schnittwunden",
  "schnittverletzung": "schnittwunden",
  "zeckenbiss": "zeckenbisse",
  "zeckenstich": "zeckenbisse",
  "borreliose vorbeugung": "zeckenbisse",
  "mückenstiche": "insektenstiche",
  "bienenstich": "insektenstiche",
  "wespenstich": "insektenstiche",
  
  // Stoffwechsel
  "blutzucker": "diabetes",
  "zuckerkrankheit": "diabetes",
  "polyneuropathie": "nervenschäden",
  "kribbeln": "nervenschäden",
  "taubheitsgefühl": "nervenschäden",
  
  // Mangelerscheinungen
  "b12": "vitamin-b12-mangel",
  "b12 mangel": "vitamin-b12-mangel",
  "vitamin d": "vitamin-d-mangel",
  "d3 mangel": "vitamin-d-mangel",
  "sonnenvitamin": "vitamin-d-mangel",
  "magnesium": "magnesiummangel",
  "mg mangel": "magnesiummangel",
  "muskelkrämpfe nachts": "magnesiummangel",
  "zink": "zinkmangel",
  "zn mangel": "zinkmangel",
  "eisen": "eisenmangel",
  "anämie": "eisenmangel",
  "blutarmut": "eisenmangel",
  "traubenkernextrakt": "opc-mangel",
  "opc": "opc-mangel",
  
  // Sonstiges
  "erbrechen": "übelkeit",
  "brechreiz": "übelkeit",
  "seekrankheit": "reisekrankheit",
  "reiseübelkeit": "reisekrankheit",
  "gedächtnisprobleme": "konzentrationsprobleme",
  "vergesslichkeit": "konzentrationsprobleme",
  "brainfog": "konzentrationsprobleme",
  "brain fog": "konzentrationsprobleme",
  "schwermetalle": "entgiftung",
  "entgiften": "entgiftung",
  "detox": "entgiftung",
  "fettleber": "leberprobleme",
  "leber": "leberprobleme",
  "ohrgeräusche": "tinnitus",
  "ohrrauschen": "tinnitus",
  "haare fallen aus": "haarausfall",
  "dünne haare": "haarausfall",
  "wunde": "wundheilung",
  "verletzung": "wundheilung",
  "schürfwunde": "wundheilung",
  "hefepilz": "candida",
  "pilz": "candida",
  "darmpilz": "candida",

  // Abnehmen & Gewicht
  "gewicht verlieren": "abnehmen",
  "diät": "abnehmen",
  "fett verbrennen": "abnehmen",
  "übergewicht": "abnehmen",
  "gewichtsverlust": "abnehmen",
  "gewicht reduzieren": "abnehmen",
  "abspecken": "abnehmen",
  "stoffwechsel": "stoffwechsel-ankurbeln",
  "metabolismus": "stoffwechsel-ankurbeln",
  "langsamer stoffwechsel": "stoffwechsel-ankurbeln",

  // Fieber & Grippe
  "erhöhte temperatur": "fieber",
  "temperatur": "fieber",
  "fiebersenken": "fieber",
  "hohes fieber": "fieber",
  "influenza": "grippe",
  "echte grippe": "grippe",

  // Schwangerschaft & Stillen
  "schwanger": "schwangerschaft",
  "baby bekommen": "schwangerschaft",
  "schwanger sein": "schwangerschaft",
  "morgenübelkeit": "schwangerschaftsübelkeit",
  "übelkeit schwangerschaft": "schwangerschaftsübelkeit",
  "schwangerschaftserbrechen": "schwangerschaftsübelkeit",
  "stillzeit": "stillen",
  "muttermilch": "stillen",
  "milchbildung": "stillen",
  "brust stillen": "stillen",
  "sodbrennen schwangerschaft": "sodbrennen-schwangerschaft",
  "reflux schwangerschaft": "sodbrennen-schwangerschaft",

  // Kinder & Baby
  "baby": "kinderkrankheiten",
  "kleinkind": "kinderkrankheiten",
  "säugling": "kinderkrankheiten",
  "kind krank": "kinderkrankheiten",
  "babykoliken": "dreimonatskoliken",
  "koliken": "dreimonatskoliken",
  "dreimonatskolik": "dreimonatskoliken",
  "schreibaby": "dreimonatskoliken",
  "zähne baby": "zahnen",
  "zahnungsprobleme": "zahnen",
  "baby zahnt": "zahnen",
  "zahnungsbeschwerden": "zahnen",
  "kind schläft nicht": "kinderschlaf",
  "baby schläft nicht": "kinderschlaf",
  "einschlafprobleme kind": "kinderschlaf",

  // Wassereinlagerungen & Cellulite
  "ödeme": "wassereinlagerungen",
  "geschwollene beine": "wassereinlagerungen",
  "wasser in beinen": "wassereinlagerungen",
  "schwere beine": "wassereinlagerungen",
  "dicke beine": "wassereinlagerungen",
  "orangenhaut": "cellulite",
  "dellen": "cellulite",
  "bindegewebe": "cellulite",

  // Allergie & Histamin
  "allergisch": "allergie",
  "allergien": "allergie",
  "hautausschlag allergie": "allergie",
  "histamin": "histaminintoleranz",
  "histaminunverträglichkeit": "histaminintoleranz",
  "histaminose": "histaminintoleranz",

  // Schilddrüse
  "schilddrüsenunterfunktion": "schilddrüse",
  "schilddrüsenüberfunktion": "schilddrüse",
  "hashimoto": "schilddrüse",
  "thyreoiditis": "schilddrüse",
  "basedow": "schilddrüse",

  // ADHS & Konzentration
  "aufmerksamkeitsstörung": "adhs",
  "hyperaktiv": "adhs",
  "hyperaktivität": "adhs",
  "ads": "adhs",
  "unkonzentriert": "adhs",

  // Augen
  "konjunktivitis": "bindehautentzündung",
  "gerötete augen": "bindehautentzündung",
  "verklebte augen": "bindehautentzündung",

  // Verdauung (weitere)
  "bauch aufgebläht": "blähungen",
  "dicker bauch": "blähungen",
  "ibs": "reizdarm",
  "reizdarmsyndrom": "reizdarm",
  "nervöser darm": "reizdarm",

  // Weitere
  "heißhungerattacken": "heißhunger",
  "süßhunger": "heißhunger",
  "zuckersucht": "heißhunger",
  "wadenkrampf": "wadenkrämpfe",
  "nächtliche krämpfe": "wadenkrämpfe",
  "beinkrämpfe": "wadenkrämpfe"
};

// Hauptdaten - hier nur die wichtigsten für Hero-Suche (kompakt)
export const remedyData: Record<string, AilmentData> = {
  // ATEMWEGE
  "atemprobleme": {
    description: "Atemnot, Asthma und Atemwegserkrankungen können mit natürlichen Mitteln effektiv unterstützt werden.",
    remedies: [
      { name: "Alantwurzel", benefit: "Fördert Lungenregeneration, schleimlösend" },
      { name: "Cordyceps", benefit: "Verbessert Sauerstoffverwertung um bis zu 55%" },
      { name: "Thymian", benefit: "Antibakteriell, öffnet die Atemwege" },
      { name: "Eukalyptus", benefit: "Löst Verschleimung, erleichtert Atmung" }
    ],
    page: 14,
    category: "Atemwege",
    whenToSeeDoctor: "Bei Atemnot in Ruhe, bläulichen Lippen, pfeifenden Atemgeräuschen oder Fieber über 38,5°C.",
    applicationForms: ["Tee", "Inhalation", "Kapseln"],
    relatedConditions: ["bronchitis", "husten", "erkältung"]
  },
  "bronchitis": {
    description: "Bei akuter und chronischer Bronchitis helfen schleimlösende und entzündungshemmende Naturmittel.",
    remedies: [
      { name: "Alantwurzel", benefit: "Schleimlösend, regeneriert Bronchialschleimhaut" },
      { name: "Efeu", benefit: "Löst festsitzenden Schleim, krampflösend" },
      { name: "Spitzwegerich", benefit: "Reizlindernd, antibakteriell" },
      { name: "Thymian", benefit: "Entkrampft Bronchien, löst Schleim" }
    ],
    page: 14,
    category: "Atemwege",
    whenToSeeDoctor: "Bei Husten mit blutigem Auswurf, Fieber über 39°C, Atemnot oder wenn Symptome länger als 10 Tage anhalten.",
    applicationForms: ["Tee", "Sirup", "Inhalation"],
    relatedConditions: ["husten", "erkältung", "atemprobleme"]
  },
  "husten": {
    description: "Reizhusten und produktiver Husten lassen sich mit verschiedenen Heilpflanzen effektiv behandeln.",
    remedies: [
      { name: "Thymian", benefit: "Antibakteriell, krampflösend bei Reizhusten" },
      { name: "Spitzwegerich", benefit: "Schleimhautschützend, reizlindernd" },
      { name: "Eibisch", benefit: "Bildet schützende Schleimschicht" },
      { name: "Efeu", benefit: "Löst Schleim, entkrampft die Bronchien" },
      { name: "Isländisch Moos", benefit: "Lindert trockenen Reizhusten" }
    ],
    page: 118,
    category: "Atemwege",
    whenToSeeDoctor: "Bei Husten mit blutigem Auswurf, Atemnot, Fieber über 38,5°C oder wenn Husten länger als 3 Wochen anhält.",
    applicationForms: ["Tee", "Sirup", "Lutschpastillen", "Inhalation"],
    relatedConditions: ["erkältung", "bronchitis", "halsschmerzen"]
  },
  "erkältung": {
    description: "Grippale Infekte und Erkältungen können mit antiviralen und immunstärkenden Naturmitteln schneller überwunden werden.",
    remedies: [
      { name: "Basilikum", benefit: "Antiviral, antibakteriell, fiebersenkend" },
      { name: "Ingwer", benefit: "Wärmend, immunstärkend, entzündungshemmend" },
      { name: "Citrizidal (GKE)", benefit: "Natürliches Antibiotikum aus Grapefruitkernen" },
      { name: "Holunderblüten", benefit: "Schweißtreibend, fiebersenkend" },
      { name: "Echinacea", benefit: "Stärkt die Immunabwehr nachweislich" }
    ],
    page: 27,
    category: "Immunsystem",
    whenToSeeDoctor: "Bei Fieber über 39°C, starken Kopf- oder Gliederschmerzen, Atemnot oder Symptomen länger als 10 Tage.",
    applicationForms: ["Tee", "Kapseln", "Tropfen", "Inhalation"],
    relatedConditions: ["husten", "halsschmerzen", "fieber", "grippe"]
  },
  "halsschmerzen": {
    description: "Halsschmerzen und Rachenentzündungen sprechen gut auf desinfizierende und entzündungshemmende Naturmittel an.",
    remedies: [
      { name: "Salbei", benefit: "Desinfizierend, zusammenziehend, schmerzlindernd" },
      { name: "Propolis", benefit: "Natürliches Antibiotikum der Bienen" },
      { name: "Kamille", benefit: "Entzündungshemmend, beruhigend" },
      { name: "Thymian", benefit: "Antibakteriell, schleimlösend" }
    ],
    page: 124,
    category: "Atemwege",
    whenToSeeDoctor: "Bei starken Schluckbeschwerden, Fieber über 38,5°C, eitrigen Belägen oder Symptomen länger als 5 Tage.",
    applicationForms: ["Gurgellösung", "Tee", "Lutschtabletten", "Spray"],
    relatedConditions: ["erkältung", "husten", "fieber"]
  },

  // NERVEN & PSYCHE
  "stress": {
    description: "Chronischer Stress erschöpft den Körper. Adaptogene helfen, die Stressresistenz natürlich zu stärken.",
    remedies: [
      { name: "Ashwagandha", benefit: "Adaptogen, senkt Cortisol, beruhigend" },
      { name: "Rhodiola", benefit: "Erhöht Stressresistenz, energetisierend" },
      { name: "Melisse", benefit: "Beruhigend, angstlösend, schlaffördernd" },
      { name: "Lavendel", benefit: "Entspannend, fördert innere Ruhe" },
      { name: "GABA", benefit: "Hemmt Überreizung im Nervensystem" }
    ],
    page: 156,
    category: "Entspannung",
    whenToSeeDoctor: "Bei anhaltender Erschöpfung, Konzentrationsstörungen, körperlichen Symptomen wie Herzrasen oder wenn der Alltag nicht mehr bewältigt werden kann.",
    applicationForms: ["Kapseln", "Tee", "Tropfen", "Aromatherapie"],
    relatedConditions: ["schlafprobleme", "angst", "erschöpfung"]
  },
  "angst": {
    description: "Angststörungen und innere Unruhe können mit beruhigenden Heilpflanzen sanft behandelt werden.",
    remedies: [
      { name: "Passionsblume", benefit: "Angstlösend, beruhigend ohne müde zu machen" },
      { name: "Lavendel", benefit: "Beruhigt das Nervensystem" },
      { name: "Johanniskraut", benefit: "Stimmungsaufhellend, bei leichten Depressionen" },
      { name: "Baldrian", benefit: "Beruhigt ohne Abhängigkeitspotenzial" }
    ],
    page: 162,
    category: "Entspannung",
    whenToSeeDoctor: "Bei Panikattacken, Angstzuständen die den Alltag beeinträchtigen, Herzrasen, Atemnot oder Suizidgedanken – sofort Hilfe suchen!",
    applicationForms: ["Kapseln", "Tropfen", "Tee", "Aromatherapie"],
    relatedConditions: ["stress", "schlafprobleme", "erschöpfung"]
  },
  "schlafprobleme": {
    description: "Einschlaf- und Durchschlafstörungen sprechen sehr gut auf pflanzliche Schlafmittel an.",
    remedies: [
      { name: "Baldrian", benefit: "Verkürzt Einschlafzeit, verbessert Schlafqualität" },
      { name: "Hopfen", benefit: "Beruhigend, verstärkt Baldrian-Wirkung" },
      { name: "Passionsblume", benefit: "Bei Gedankenkreisen, beruhigt das Nervensystem" },
      { name: "Melisse", benefit: "Entspannend, beruhigt bei Unruhe" },
      { name: "Lavendel", benefit: "Fördert erholsamen Schlaf" }
    ],
    page: 89,
    category: "Entspannung",
    whenToSeeDoctor: "Bei Schlafstörungen über 4 Wochen, starker Tagesmüdigkeit, Atemaussetzern im Schlaf oder wenn Schlafmittel-Abhängigkeit droht.",
    applicationForms: ["Kapseln", "Tee", "Tropfen", "Aromatherapie"],
    relatedConditions: ["stress", "angst", "müdigkeit"]
  },

  // ENERGIE & MÜDIGKEIT
  "müdigkeit": {
    description: "Chronische Müdigkeit und Energiemangel können vielfältige Ursachen haben. Diese Mittel steigern die Vitalität.",
    remedies: [
      { name: "Aminosäuren", benefit: "Bausteine für Energie und Neurotransmitter" },
      { name: "Vitamin B12", benefit: "Essentiell für Energieproduktion" },
      { name: "Ginseng", benefit: "Adaptogen, steigert Ausdauer und Energie" }
    ],
    page: 19,
    category: "Energie"
  },
  "erschöpfung": {
    description: "Bei Burnout und totaler Erschöpfung helfen Adaptogene, die Reserven wieder aufzubauen.",
    remedies: [
      { name: "Ashwagandha", benefit: "Regeneriert bei Burnout, stärkt Nebennieren" },
      { name: "Rhodiola", benefit: "Bekämpft Erschöpfung, steigert Belastbarkeit" },
      { name: "Maca", benefit: "Energetisierend, hormonausgleichend" }
    ],
    page: 251,
    category: "Energie"
  },

  // VERDAUUNG
  "verdauungsprobleme": {
    description: "Verdauungsbeschwerden verschiedener Art können mit bewährten Heilpflanzen gelindert werden.",
    remedies: [
      { name: "Beifuß", benefit: "Traditionelle Verdauungshilfe, regt Gallensaft an" },
      { name: "Fenchel", benefit: "Entkrampfend, gegen Blähungen" },
      { name: "Pfefferminze", benefit: "Krampflösend, beruhigt den Magen" },
      { name: "Ingwer", benefit: "Fördert Verdauung, lindert Übelkeit" },
      { name: "Artischocke", benefit: "Unterstützt Leber und Galle" }
    ],
    page: 30,
    category: "Verdauung",
    whenToSeeDoctor: "Bei blutigem Stuhl, starken Bauchschmerzen, Gewichtsverlust ohne Diät, anhaltendem Erbrechen oder Symptomen über 2 Wochen.",
    applicationForms: ["Tee", "Kapseln", "Tropfen"],
    relatedConditions: ["blähungen", "sodbrennen", "übelkeit"]
  },
  "blähungen": {
    description: "Blähungen und Völlegefühl lassen sich mit karminativen Heilpflanzen schnell lindern.",
    remedies: [
      { name: "Kümmel", benefit: "Stärkstes Karminativum, löst Blähungen" },
      { name: "Anis", benefit: "Entkrampfend, verdauungsfördernd" },
      { name: "Fenchel", benefit: "Sanft, auch für Babys geeignet" },
      { name: "Pfefferminze", benefit: "Entkrampft den Darm" }
    ],
    page: 140,
    category: "Verdauung",
    whenToSeeDoctor: "Bei starken Bauchschmerzen, Blut im Stuhl, anhaltendem Durchfall/Verstopfung oder plötzlicher Änderung der Stuhlgewohnheiten.",
    applicationForms: ["Tee", "Öl (Massage)", "Kapseln"],
    relatedConditions: ["verdauungsprobleme", "sodbrennen"]
  },
  "sodbrennen": {
    description: "Überschüssige Magensäure kann mit natürlichen Mitteln neutralisiert und reguliert werden.",
    remedies: [
      { name: "Süßholzwurzel", benefit: "Schützt Magenschleimhaut, neutralisiert Säure" },
      { name: "Kamille", benefit: "Beruhigt gereizte Schleimhaut" },
      { name: "Heilerde", benefit: "Bindet überschüssige Säure" },
      { name: "Kartoffelsaft", benefit: "Neutralisiert Säure natürlich" }
    ],
    page: 146,
    category: "Verdauung",
    whenToSeeDoctor: "Bei Schluckbeschwerden, ungewolltem Gewichtsverlust, Erbrechen von Blut oder wenn Beschwerden trotz Behandlung anhalten.",
    applicationForms: ["Tee", "Kautabletten", "Tropfen"],
    relatedConditions: ["verdauungsprobleme", "blähungen"]
  },

  // GELENKE & BEWEGUNG
  "gelenkschmerzen": {
    description: "Arthrose, Arthritis und Gelenkverschleiß können mit entzündungshemmenden Mitteln behandelt werden.",
    remedies: [
      { name: "Beinwell", benefit: "Regeneriert Knorpel durch Allantoin" },
      { name: "Weihrauch", benefit: "Starker Entzündungshemmer, hemmt Knorpelabbau" },
      { name: "Kurkuma", benefit: "Curcumin wirkt stark entzündungshemmend" },
      { name: "Teufelskralle", benefit: "Traditionell bei Gelenkbeschwerden, schmerzlindernd" },
      { name: "MSM", benefit: "Schwefelverbindung für gesunde Gelenke" }
    ],
    page: 33,
    category: "Bewegung",
    whenToSeeDoctor: "Bei plötzlich stark geschwollenen oder geröteten Gelenken, Fieber, nach Verletzungen oder wenn Schmerzen trotz Behandlung zunehmen.",
    applicationForms: ["Kapseln", "Salbe", "Gel", "Tee"],
    relatedConditions: ["rückenschmerzen", "muskelkater"]
  },
  "rückenschmerzen": {
    description: "Rückenschmerzen haben oft muskuläre Ursachen und sprechen gut auf wärmende Mittel an.",
    remedies: [
      { name: "Arnika", benefit: "Entzündungshemmend, schmerzlindernd äußerlich" },
      { name: "Beinwell", benefit: "Regeneriert Gewebe, lindert Schmerzen" },
      { name: "Cayenne", benefit: "Wärmend, durchblutungsfördernd" },
      { name: "Teufelskralle", benefit: "Entzündungshemmend, schmerzlindernd" }
    ],
    page: 207,
    category: "Bewegung",
    whenToSeeDoctor: "Bei Taubheitsgefühlen, Lähmungen, Blasen-/Darmstörungen, nach Unfällen oder wenn Schmerzen ins Bein ausstrahlen.",
    applicationForms: ["Salbe", "Wärmepflaster", "Kapseln", "Bad"],
    relatedConditions: ["gelenkschmerzen", "muskelkater"]
  },

  // KOPFSCHMERZEN
  "kopfschmerzen": {
    description: "Spannungskopfschmerzen können mit entspannenden und schmerzlindernden Naturmitteln behandelt werden.",
    remedies: [
      { name: "Pfefferminzöl", benefit: "Äußerlich auf Schläfen, kühlend und entspannend" },
      { name: "Weidenrinde", benefit: "Natürliches Aspirin, entzündungshemmend" },
      { name: "Magnesium", benefit: "Entspannt Blutgefäße und Muskeln" },
      { name: "Lavendel", benefit: "Entspannend bei stressbedingten Kopfschmerzen" }
    ],
    page: 47,
    category: "Schmerzen",
    whenToSeeDoctor: "Bei plötzlich extrem starken Kopfschmerzen ('Vernichtungskopfschmerz'), mit Fieber, Nackensteife, Sehstörungen oder nach Kopfverletzungen – sofort!",
    applicationForms: ["Öl (äußerlich)", "Tee", "Kapseln"],
    relatedConditions: ["migräne", "stress", "schlafprobleme"]
  },
  "migräne": {
    description: "Migräne erfordert andere Mittel als normale Kopfschmerzen und kann vorbeugend behandelt werden.",
    remedies: [
      { name: "Mutterkraut", benefit: "Vorbeugend, reduziert Migränehäufigkeit" },
      { name: "Pestwurz", benefit: "Wissenschaftlich belegt bei Migräne" },
      { name: "Ingwer", benefit: "Lindert Übelkeit, entzündungshemmend" },
      { name: "Magnesium", benefit: "Zur Vorbeugung, entspannt Blutgefäße" }
    ],
    page: 52,
    category: "Schmerzen",
    whenToSeeDoctor: "Bei erstmaliger Migräne, veränderten Symptomen, mit Lähmungen, Sprachstörungen oder wenn Anfälle häufiger werden.",
    applicationForms: ["Kapseln", "Tee", "Tropfen"],
    relatedConditions: ["kopfschmerzen", "übelkeit", "stress"]
  },

  // IMMUNSYSTEM
  "immunschwäche": {
    description: "Ein schwaches Immunsystem kann mit immunstärkenden Naturmitteln aufgebaut werden.",
    remedies: [
      { name: "Echinacea", benefit: "Aktiviert Immunzellen, verkürzt Infekte" },
      { name: "Vitamin C", benefit: "Essentiell für Immunfunktion" },
      { name: "Zink", benefit: "Wichtig für T-Zellen und Antikörper" }
    ],
    page: 41,
    category: "Immunsystem"
  },
  "allergien": {
    description: "Allergische Reaktionen können mit antihistaminischen und immunregulierenden Mitteln gelindert werden.",
    remedies: [
      { name: "Schwarzkümmelöl", benefit: "Reguliert überschießende Immunreaktion" },
      { name: "Brennnessel", benefit: "Natürliches Antihistaminikum" },
      { name: "Quercetin", benefit: "Hemmt Histaminausschüttung" }
    ],
    page: 223,
    category: "Immunsystem"
  },
  "heuschnupfen": {
    description: "Pollenallergie und saisonale allergische Rhinitis können natürlich behandelt werden.",
    remedies: [
      { name: "Augentrost", benefit: "Speziell für allergische Augenbeschwerden" },
      { name: "Brennnessel", benefit: "Reduziert allergische Reaktion" },
      { name: "Vitamin C", benefit: "Senkt Histaminspiegel natürlich" }
    ],
    page: 229,
    category: "Immunsystem"
  },

  // HAUT
  "akne": {
    description: "Unreine Haut und Akne können von innen und außen natürlich behandelt werden.",
    remedies: [
      { name: "Teebaumöl", benefit: "Antibakteriell, tötet Akne-Bakterien" },
      { name: "Zink", benefit: "Reguliert Talgproduktion, entzündungshemmend" },
      { name: "Heilerde", benefit: "Entgiftend, absorbiert überschüssiges Fett" }
    ],
    page: 184,
    category: "Haut"
  },
  "neurodermitis": {
    description: "Atopische Dermatitis spricht gut auf bestimmte Fettsäuren und entzündungshemmende Mittel an.",
    remedies: [
      { name: "Borretschöl", benefit: "Reich an Gamma-Linolensäure, heilt von innen" },
      { name: "Nachtkerzenöl", benefit: "Essentielle Fettsäuren für gesunde Haut" },
      { name: "Schwarzkümmelöl", benefit: "Entzündungshemmend, juckreizlindernd" }
    ],
    page: 36,
    category: "Haut"
  },

  // ABNEHMEN & STOFFWECHSEL
  "abnehmen": {
    description: "Natürliche Unterstützung beim Gewichtsverlust durch Stoffwechselanregung und Appetitzügelung.",
    remedies: [
      { name: "Grüner Tee", benefit: "Kurbelt Stoffwechsel an, fördert Fettverbrennung" },
      { name: "Glucomannan", benefit: "Quellstoff, sättigt natürlich" },
      { name: "Chrom Picolinat", benefit: "Reguliert Blutzucker, reduziert Heißhunger" }
    ],
    page: 95,
    category: "Stoffwechsel"
  },

  // FIEBER & GRIPPE
  "fieber": {
    description: "Fieber ist eine natürliche Abwehrreaktion. Sanfte Naturmittel können es regulieren.",
    remedies: [
      { name: "Lindenblüten", benefit: "Schweißtreibend, fiebersenkend" },
      { name: "Holunderblüten", benefit: "Traditionelles Fiebermittel, immunstärkend" },
      { name: "Weidenrinde", benefit: "Natürliches Aspirin, senkt Fieber" },
      { name: "Wadenwickel", benefit: "Klassische Methode zur Fiebersenkung" },
      { name: "Ingwer", benefit: "Wärmend, unterstützt Immunabwehr" }
    ],
    page: 112,
    category: "Immunsystem",
    whenToSeeDoctor: "Bei Fieber über 39°C (Erwachsene) oder 38,5°C (Kinder unter 3), länger als 3 Tage, mit Nackensteife, Atemnot oder Hautausschlag.",
    applicationForms: ["Tee", "Wickel", "Bad"],
    relatedConditions: ["erkältung", "grippe", "husten"]
  },
  "grippe": {
    description: "Bei echter Grippe können antivirale und immunstärkende Mittel die Genesung beschleunigen.",
    remedies: [
      { name: "Holunder (Sambucus)", benefit: "Verkürzt Grippedauer um bis zu 4 Tage" },
      { name: "Echinacea", benefit: "Stärkt Immunabwehr, antiviral" },
      { name: "Vitamin C + Zink", benefit: "Hochdosiert bei ersten Symptomen" },
      { name: "Ingwer", benefit: "Wärmend, entzündungshemmend" }
    ],
    page: 115,
    category: "Immunsystem",
    whenToSeeDoctor: "Bei Atemnot, hohem Fieber über 40°C, starken Brustschmerzen, Verwirrtheit oder wenn sich Symptome nach 7 Tagen verschlimmern.",
    applicationForms: ["Tee", "Kapseln", "Sirup"],
    relatedConditions: ["fieber", "erkältung", "husten"]
  },

  // SCHWANGERSCHAFT
  "schwangerschaft": {
    description: "In der Schwangerschaft sind viele Medikamente tabu. Diese Naturmittel gelten als sicher.",
    remedies: [
      { name: "Ingwer", benefit: "Gegen Schwangerschaftsübelkeit, gut untersucht" },
      { name: "Folsäure", benefit: "Essentiell für Neuralrohrentwicklung" },
      { name: "Magnesium", benefit: "Gegen Wadenkrämpfe, entspannend" },
      { name: "Himbeerblättertee", benefit: "Traditionell zur Geburtsvorbereitung" }
    ],
    page: 200,
    category: "Frauengesundheit",
    whenToSeeDoctor: "Bei Blutungen, starken Bauchschmerzen, ausbleibendem Kindsbewegungen, Wassereinlagerungen im Gesicht oder Kopfschmerzen mit Sehstörungen – sofort!",
    applicationForms: ["Tee", "Kapseln"],
    relatedConditions: ["übelkeit"]
  },

  // KINDER
  "kinderkrankheiten": {
    description: "Sanfte Naturmittel sind ideal für Kinder. Sie stärken das Immunsystem ohne aggressive Chemie.",
    remedies: [
      { name: "Kamillentee", benefit: "Beruhigend bei Bauchschmerzen" },
      { name: "Holundersirup", benefit: "Bei Erkältungen, schmeckt Kindern" },
      { name: "Propolis", benefit: "Natürliches Antibiotikum" },
      { name: "Fencheltee", benefit: "Bei Blähungen und Bauchweh" }
    ],
    page: 210,
    category: "Kinder",
    whenToSeeDoctor: "Bei Fieber über 38,5°C (unter 3 Monate: über 38°C), Teilnahmslosigkeit, Trinkverweigerung, Hautausschlag mit Fieber oder Atemnot.",
    applicationForms: ["Tee", "Sirup", "Globuli"],
    relatedConditions: ["fieber", "erkältung", "husten"]
  },

  // DIABETES
  "diabetes": {
    description: "Der Blutzucker lässt sich mit natürlichen Mitteln stabilisieren und Folgeschäden vorbeugen.",
    remedies: [
      { name: "Alpha-Liponsäure", benefit: "Stabilisiert Blutzucker, schützt Nerven" },
      { name: "Chrom Picolinat", benefit: "Verbessert Insulinsensitivität" },
      { name: "Zimt", benefit: "Senkt Blutzucker, verbessert Insulinwirkung" }
    ],
    page: 17,
    category: "Stoffwechsel"
  },

  // BLUTHOCHDRUCK
  "bluthochdruck": {
    description: "Hoher Blutdruck kann mit gefäßerweiternden und beruhigenden Naturmitteln gesenkt werden.",
    remedies: [
      { name: "Knoblauch", benefit: "Senkt Blutdruck, verbessert Durchblutung" },
      { name: "Weißdorn", benefit: "Stärkt Herz, reguliert Blutdruck" },
      { name: "Olivenblatt", benefit: "Gefäßerweiternd, blutdrucksenkend" }
    ],
    page: 263,
    category: "Herz-Kreislauf"
  },

  // ALLERGIE
  "allergie": {
    description: "Allergische Reaktionen können mit natürlichen Antihistaminika und immunmodulierenden Mitteln gemildert werden.",
    remedies: [
      { name: "Schwarzkümmelöl", benefit: "Natürliches Antihistaminikum" },
      { name: "Quercetin", benefit: "Stabilisiert Mastzellen" },
      { name: "Vitamin C hochdosiert", benefit: "Senkt Histaminspiegel" }
    ],
    page: 231,
    category: "Immunsystem"
  }
};

// Hilfsfunktionen
export const sanitizeInput = (input: string): string => {
  return input
    .replace(/[^a-zA-ZäöüÄÖÜßéèêàáâ\s\-]/g, "")
    .slice(0, 50)
    .toLowerCase()
    .trim();
};

export const findRemedy = (searchTerm: string): { key: string; data: AilmentData } | null => {
  const sanitized = sanitizeInput(searchTerm);
  const aliasMatch = aliases[sanitized];
  const key = aliasMatch || sanitized;
  
  if (remedyData[key]) {
    return { key, data: remedyData[key] };
  }
  return null;
};

export const getSuggestions = (query: string): string[] => {
  const sanitized = sanitizeInput(query);
  if (sanitized.length < 2) return [];

  // Erst Aliase prüfen
  const aliasMatch = aliases[sanitized];
  if (aliasMatch && remedyData[aliasMatch]) {
    return [aliasMatch];
  }

  // Partial Alias Matching
  const partialAliasMatches = Object.entries(aliases)
    .filter(([alias]) => alias.includes(sanitized) || sanitized.includes(alias.slice(0, 4)))
    .map(([, target]) => target);

  // Dann direkte Matches
  const directMatches = Object.keys(remedyData).filter(
    (key) => key.includes(sanitized) || sanitized.includes(key.slice(0, 4))
  );

  // Kombinieren und Duplikate entfernen
  const combined = [...new Set([...partialAliasMatches, ...directMatches])];
  return combined.slice(0, 6);
};
